module.exports = __webpack_public_path__ + "static/images/common-2.a7585dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/common-2.png
// module id = dVfm
// module chunks = 8